<!--
Author: TangChen
Date: 2018-09-17
Desc: 我的资产组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-my-plan bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/gfund' }">
                    基金定投
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-table :data="gfund" style="width: 100%" class="tab-list-tit">
            <el-table-column label="基金名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <i
                        v-if="scope.row.planflag==='2'||scope.row.planflag==='6'"
                        class="wisdom-icon"
                        title="智慧定投"
                    >智</i>
                    <span v-html="getFundName(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column
                prop="firstinvestdate"
                width="110"
                label="首次扣款日期"
                align="center"
                :formatter="formatterDate"
            />
            <el-table-column prop="periodremark" label="扣款周期" width="110" align="center" />
            <el-table-column label="扣款金额" align="center">
                <template slot-scope="scope">
                    <div v-html="formatterNum(scope.row.firstinvestamount)" />
                </template>
            </el-table-column>
            <el-table-column label="银行卡" align="center" width="240">
                <template slot-scope="scope">
                    <div class="bank-img-sel list-bank">
                        <span class="k-text-flow">{{ $cache.getDict('110080',scope.row.channelid)+'[尾号'+scope.row.bankcard.substr(-4,4)+']' }}</span>
                        <!--<i class="paycenter">{{ $cache.getDict('110079',scope.row.paycenterid) }}</i>-->
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="定投状态" align="center" :formatter="formatterStatus" />
            <el-table-column label="操作" align="center" :width="100">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.iswarn!=='1'"
                        type="info"
                        plain
                        size="small"
                        v-on:click.stop="showDetail(scope.row.planno)"
                    >
                        查看明细
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "MyPlan",
    mixins: [mixin],
    data () {
        return {
            gfund: [],
            fundDetail: {}
        };
    },
    created () {
        this.getFundLists();
    },
    methods: {
        showDetail (id) {
            const fund = this.gfund.filter(item => {
                return item.planno === id;
            })[0];
            if (fund) {
                const _x = Object.assign({}, fund);
                sessionStorage.setItem("plandetail", JSON.stringify(_x));
                this.$router.push({ name: "plandetail", query: { fundcode: _x.fundcode } });
            }
        },
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterStatus (row, column, value) {
            return this.$cache.getDict("110008", value);
        },
        // 获取基金名称显示
        getFundName (val, flag) {
            let _k = "";
            let _m = ",";
            if (!flag) {
                _m = "<br/>";
                if (val.busitype === "7" || val.planpaytype === "2") {
                    _k = "<b class=\"wisdom-icon\" title=\"现金宝\">现</b>";
                }
            }
            if (val.fundcode.indexOf(",") === -1) {
                return _k + val.fundname + "(" + (val.fundcode === "515981" ? "515980" : val.fundcode) + ")";
            }
            const _x = val.fundcode.split(",");
            const _y = val.fundname.split(",");
            let _z = "";
            // 定转显示
            for (let i in _x) {
                _z += _k + _y[i] + "(" + _x[i] + ")" + _m;
            }
            return _z;
        },
        formatterNum (value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        // 获取资产信息
        getFundLists () {
            const _this = this;
            this.$util.request("acct/plan").then(res => {
                if (res.data) {
                    _this.gfund = res.data[0];
                    _this.gfund = _this.$util.getCodeOnly(_this.gfund, { code: "mainplanno", data: ["fundname", "fundcode", "risklevel", "firstinvestamount", "planno"] }, ",");
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-my-plan {
    .wisdom-icon {
        font-size: $f12;
        display: inline-block;
        font-style: normal;
        background-color: $color-c;
        color: $text-color6;
        width: 18px;
        height: 18px;
        line-height: 18px;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        margin-right: 4px;
    }
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: $border-color3;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 50px;
        padding: 0 20px;
        .el-tabs__active-bar {
            background: $color-a;
        }
        .el-tabs__item {
            font-size: $f18;
            &.is-active {
                color: $color-a;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
}
</style>
